<template>
  <div class="container-fluid m-0 p-0">
    <div class="row text-left bg-light border-bottom py-3 d-flex justify-content-between">
      <div class="col-auto">
        <h5 class="mb-0 font-weight-bold">Who's Onboard List</h5>
      </div>
      <div class="col-auto">
        <button class="btn btn-xs btn-outline-secondary px-2 mr-1" title="Go to Previous Page"
                @click="goBack"
        >
          <span class="fas fa-backward"></span>
          Go Back
        </button>
      </div>
    </div>

    <div class="row py-2">
      <div class="col-12 text-left">
        <div class="form-inline d-flex justify-content-start w-100">
          <div class="form-group py-1 mr-3">
            <label for="crewOnboardType" class="form-control-xs font-weight-bold">
              Crew Onboard Filter Type:
            </label>
            <select id="crewOnboardType"
                    v-model="params.crewOnboardFilterType"
                    class="form-control form-control-xs mx-2">
            <option :value="1">Custom Search</option>
              <option :value="2">Fixed Search</option>
              <option :value="3">Periodical Search</option>
            </select>
          </div>
          <div class="d-flex" v-if="params.crewOnboardFilterType === 1">
            <div class="form-group py-1 mr-3">
              <label for="onboardFrom" class="form-control-xs font-weight-bold">
                Onboard From:
              </label>
              <input type="date" id="onboardFrom" class="form-control form-control-xs mx-2"
                     v-model="params.onboard_from" :disabled="isLoading">
            </div>
            <div class="form-group py-1 mr-3">
              <label for="onboardTo" class="form-control-xs font-weight-bold">
                Onboard To:
              </label>
              <input type="date" id="onboardTo" class="form-control form-control-xs mx-2"
                     v-model="params.onboard_to" :disabled="isLoading">
            </div>
          </div>
          <div class="d-flex" v-if="params.crewOnboardFilterType === 2">
            <div class="form-group py-1 mr-3">
              <label for="onboard_above" class="form-control-xs font-weight-bold">Crews Onboard Above: </label>
              <select name="onboard_above" id="onboard_above" class="form-control form-control-xs mx-2"
                      v-model="params.filter.minimumOnboardMonth" :disabled="isLoading">
                <option v-for="minimumMonthsOnboard in 5"
                        :key="minimumMonthsOnboard"
                        :value="minimumMonthsOnboard + 7"
                        :title="(minimumMonthsOnboard + 7) + ' months' "
                >{{(minimumMonthsOnboard + 7) + ' months'  }}
                </option>
              </select>
            </div>
          </div>
          <div class="d-flex" v-if="params.crewOnboardFilterType === 3">
            <div class="form-group py-1 mr-3">
              <label for="onboardFrom" class="form-control-xs font-weight-bold">
                Minimum Onboard Month:
              </label>
              <input type="number" min="1" :max="params.filter.maximumPeriodMonth" class="form-control form-control-xs mx-2" v-model="params.filter.minimumPeriodMonth"
               @input="validateNumberInput('min', $event.target.value)"
               :disabled="isLoading">
            </div>
            <div class="form-group py-1 mr-3">
              <label for="onboardTo" class="form-control-xs font-weight-bold">
                Maximum Onboard Month:
              </label>
              <input class="form-control form-control-xs mx-2" type="number" :min="params.filter.minimumPeriodMonth" max="13" v-model="params.filter.maximumPeriodMonth"
               @input="validateNumberInput('max', $event.target.value)"
               :disabled="isLoading">
            </div>
          </div>
        </div>
        <div class="form-inline d-flex justify-content-start w-100">
          <div class="form-group py-1 mr-3" v-if="isPrincipal">
            <label for="manning" class="form-control-xs font-weight-bold">Manning: </label>
            <select name="manning" id="manning" class="form-control form-control-xs mx-2"
                    v-model="params.manning_id" :disabled="isLoading" >
              <option :value="null" id="manningOption0" disabled selected>---Select Manning ---</option>
              <option value="">ALL MANNING</option>
              <option v-for="manningKey in manningKeys"
                      :key="manningKey.id"
                      :title="manningKey.name"
                      :value="manningKey.id">
                {{ manningKey.alias }}
              </option>
            </select>
          </div>
          <div class="form-group py-1 mr-3">
            <label for="vessels" class="form-control-xs font-weight-bold">Vessel: </label>
            <select class="form-control form-control-xs mx-2" id="vessels"
                    v-model="params.vessel_id" :disabled="isLoading">
              <option :value="null" id="vesselOption0" disabled selected>---Select Vessel ---</option>
              <option value="">ALL VESSEL</option>
              <option v-for="vessel in vesselKeys" :key="vessel.id" :value="vessel.id">
                {{ vessel.name }}
              </option>
            </select>
          </div>
          <div class="form-group py-1 mr-3">
            <label for="rank" class="form-control-xs font-weight-bold">Rank: </label>
            <select name="rank" id="rank" class="form-control form-control-xs mx-2"
                    v-model="params.rank_id" :disabled="isLoading">
              <option :value="null" id="rankOption0" disabled selected>---Select Ranks ---</option>
              <option value="">ALL RANKS</option>
              <option v-for="rankKey in rankKeys"
                      :key="rankKey.id"
                      :value="rankKey.id"
                      :title="rankKey.name"
              >{{ rankKey.alias }}
              </option>
            </select>
          </div>
          <div class="form-group py-1 mr-3">
            <label for="rank" class="form-control-xs font-weight-bold">Nationality: </label>
            <select name="rank" id="rank" class="form-control form-control-xs mx-2"
                    v-model="params.natl_id" :disabled="isLoading">
              <option :value="null" id="natlOption0" disabled selected>---Select Nationality ---</option>
              <option value="">ALL NATIONALITIES</option>
              <option v-for="natlKey in natlKeys"
                      :key="natlKey.id"
                      :value="natlKey.id"
                      :title="natlKey.natl"
              >{{ natlKey.natl }}
              </option>
            </select>
          </div>
        </div>
      </div>
      <div class="col-10 text-center d-flex align-items-center mt-3">
        <nav aria-label="...">
          <ul class="pagination text-smallest mb-0 pb-0">
            <li
                class="page-item"
                :class="{ disabled: pagination.currentPage === 1 }"
            >
              <button class="page-link" @click="setPage(1)">First</button>
            </li>

            <li
                v-for="page in paginationPages"
                :key="page"
                class="page-item"
                :class="{
                disabled: page === '...',
                active: page === pagination.currentPage,
              }"
            >
              <button class="page-link" @click="setPage(page)">
                {{ page }}
              </button>
            </li>

            <li
                class="page-item"
                :class="{
                disabled: pagination.currentPage === pagination.lastPage,
              }"
            >
              <button class="page-link" @click="setPage(pagination.lastPage)">
                Last
              </button>
            </li>
          </ul>
        </nav>
        <small class="mx-3">{{
            `${pagination.from} to ${pagination.to} of ${pagination.total}`
          }}</small>
      </div>
      <div class="col-2 text-center d-flex justify-content-end align-items-center">
        <button id="generateReport" class="btn btn-primary btn-xs p-1 d-flex align-items-center"
                :disabled="params.vessel_id === null && params.manning_id === null && params.rank_id === null && params.natl_id === null"
                v-if="!isLoading"
                @click="downloadOnboardList">
          <i class="fas fa-file-pdf fa-2x mx-1"></i>
          Generate Report
        </button>
      </div>

      <div class="col col-12">
        <table class="table table-hover table-bordered table-template-1 text-small table-striped my-2 sticky-header">
          <thead>
          <tr>
            <th width="1">No</th>
            <th v-show="!params.rank_id" style="cursor: pointer" @click="toggleTableHeader('rank')">
              Rank <span v-if="params.sort_by.key === 'rank'">
                  <svg class="svg-inline--fa fa-arrow-up fa-w-14" :class="isCurrentKeyDirection('rank', 'asc') ? 'current_direction' : ''" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="arrow-up" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" data-fa-i2svg=""><path fill="currentColor" d="M34.9 289.5l-22.2-22.2c-9.4-9.4-9.4-24.6 0-33.9L207 39c9.4-9.4 24.6-9.4 33.9 0l194.3 194.3c9.4 9.4 9.4 24.6 0 33.9L413 289.4c-9.5 9.5-25 9.3-34.3-.4L264 168.6V456c0 13.3-10.7 24-24 24h-32c-13.3 0-24-10.7-24-24V168.6L69.2 289.1c-9.3 9.8-24.8 10-34.3.4z"></path></svg>

                  <svg class="svg-inline--fa fa-arrow-down fa-w-14" :class="isCurrentKeyDirection('rank', 'desc') ? 'current_direction' : ''" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="arrow-down" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" data-fa-i2svg=""><path fill="currentColor" d="M413.1 222.5l22.2 22.2c9.4 9.4 9.4 24.6 0 33.9L241 473c-9.4 9.4-24.6 9.4-33.9 0L12.7 278.6c-9.4-9.4-9.4-24.6 0-33.9l22.2-22.2c9.5-9.5 25-9.3 34.3.4L184 343.4V56c0-13.3 10.7-24 24-24h32c13.3 0 24 10.7 24 24v287.4l114.8-120.5c9.3-9.8 24.8-10 34.3-.4z"></path></svg>
                </span>
            </th>
            <th style="cursor: pointer" @click="toggleTableHeader('name')">
              Name <span v-if="params.sort_by.key === 'name'">
                  <svg class="svg-inline--fa fa-arrow-up fa-w-14" :class="isCurrentKeyDirection('name', 'asc') ? 'current_direction' : ''" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="arrow-up" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" data-fa-i2svg=""><path fill="currentColor" d="M34.9 289.5l-22.2-22.2c-9.4-9.4-9.4-24.6 0-33.9L207 39c9.4-9.4 24.6-9.4 33.9 0l194.3 194.3c9.4 9.4 9.4 24.6 0 33.9L413 289.4c-9.5 9.5-25 9.3-34.3-.4L264 168.6V456c0 13.3-10.7 24-24 24h-32c-13.3 0-24-10.7-24-24V168.6L69.2 289.1c-9.3 9.8-24.8 10-34.3.4z"></path></svg>

                  <svg class="svg-inline--fa fa-arrow-down fa-w-14" :class="isCurrentKeyDirection('name', 'desc') ? 'current_direction' : ''" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="arrow-down" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" data-fa-i2svg=""><path fill="currentColor" d="M413.1 222.5l22.2 22.2c9.4 9.4 9.4 24.6 0 33.9L241 473c-9.4 9.4-24.6 9.4-33.9 0L12.7 278.6c-9.4-9.4-9.4-24.6 0-33.9l22.2-22.2c9.5-9.5 25-9.3 34.3.4L184 343.4V56c0-13.3 10.7-24 24-24h32c13.3 0 24 10.7 24 24v287.4l114.8-120.5c9.3-9.8 24.8-10 34.3-.4z"></path></svg>
                </span>
            </th>
            <th>IPN</th>
            <th>Embark Date</th>
            <th>Embark Status</th>
            <th style="cursor: pointer" @click="toggleTableHeader('disembark_date')">
              Disembark Date <span v-if="params.sort_by.key === 'disembark_date'">
                  <svg class="svg-inline--fa fa-arrow-up fa-w-14" :class="isCurrentKeyDirection('disembark_date', 'asc') ? 'current_direction' : ''" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="arrow-up" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" data-fa-i2svg=""><path fill="currentColor" d="M34.9 289.5l-22.2-22.2c-9.4-9.4-9.4-24.6 0-33.9L207 39c9.4-9.4 24.6-9.4 33.9 0l194.3 194.3c9.4 9.4 9.4 24.6 0 33.9L413 289.4c-9.5 9.5-25 9.3-34.3-.4L264 168.6V456c0 13.3-10.7 24-24 24h-32c-13.3 0-24-10.7-24-24V168.6L69.2 289.1c-9.3 9.8-24.8 10-34.3.4z"></path></svg>

                  <svg class="svg-inline--fa fa-arrow-down fa-w-14" :class="isCurrentKeyDirection('disembark_date', 'desc') ? 'current_direction' : ''" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="arrow-down" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" data-fa-i2svg=""><path fill="currentColor" d="M413.1 222.5l22.2 22.2c9.4 9.4 9.4 24.6 0 33.9L241 473c-9.4 9.4-24.6 9.4-33.9 0L12.7 278.6c-9.4-9.4-9.4-24.6 0-33.9l22.2-22.2c9.5-9.5 25-9.3 34.3.4L184 343.4V56c0-13.3 10.7-24 24-24h32c13.3 0 24 10.7 24 24v287.4l114.8-120.5c9.3-9.8 24.8-10 34.3-.4z"></path></svg>
                </span>
            </th>
            <th>Disembark Status</th>
            <th style="cursor: pointer" @click="toggleTableHeader('onboardPeriod')">
              Time Onboard<span v-if="params.sort_by.key === 'onboardPeriod'">
                  <svg class="svg-inline--fa fa-arrow-up fa-w-14" :class="isCurrentKeyDirection('onboardPeriod', 'asc') ? 'current_direction' : ''" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="arrow-up" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" data-fa-i2svg=""><path fill="currentColor" d="M34.9 289.5l-22.2-22.2c-9.4-9.4-9.4-24.6 0-33.9L207 39c9.4-9.4 24.6-9.4 33.9 0l194.3 194.3c9.4 9.4 9.4 24.6 0 33.9L413 289.4c-9.5 9.5-25 9.3-34.3-.4L264 168.6V456c0 13.3-10.7 24-24 24h-32c-13.3 0-24-10.7-24-24V168.6L69.2 289.1c-9.3 9.8-24.8 10-34.3.4z"></path></svg>

                  <svg class="svg-inline--fa fa-arrow-down fa-w-14" :class="isCurrentKeyDirection('onboardPeriod', 'desc') ? 'current_direction' : ''" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="arrow-down" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" data-fa-i2svg=""><path fill="currentColor" d="M413.1 222.5l22.2 22.2c9.4 9.4 9.4 24.6 0 33.9L241 473c-9.4 9.4-24.6 9.4-33.9 0L12.7 278.6c-9.4-9.4-9.4-24.6 0-33.9l22.2-22.2c9.5-9.5 25-9.3 34.3.4L184 343.4V56c0-13.3 10.7-24 24-24h32c13.3 0 24 10.7 24 24v287.4l114.8-120.5c9.3-9.8 24.8-10 34.3-.4z"></path></svg>
                </span>
            </th>
            <th v-show="!params.vessel_id">Vessel</th>
<!--            <th>Passport</th>-->
<!--            <th>Seaman's Book</th>-->
            <th>Scholarship</th>
            <th v-show="!params.natl_id">Nationality</th>
            <th>Contract Validity</th>
          </tr>
          </thead>

          <tbody class="text-small">
          <tr v-if="isLoading">
            <td colspan="100%">
              <app-loading></app-loading>
            </td>
          </tr>

          <template v-else>
            <tr v-for="(crew, index) in onboardCrewList.data" :key="crew.id">
              <td class="text-center">{{ index + pagination.from }}</td>
              <td v-show="!params.rank_id" class="text-center">{{crew.rank}}</td>
              <td class="text-left">
                <router-link :to="{name:'CrewActivity',params:{id:crew.id}}" target="_blank"
                             v-if="crew.fullName" class="mb-0">{{ crew.fullName }}
                </router-link>
              </td>
              <td class="text-center">{{crew.ipn}}</td>
              <td class="text-center">{{crew.embarkationDate}}</td>
              <td class="text-center">{{crew.embarkationStatus}}</td>
              <td class="text-center" :class="crew.disembarkationDate === 'NO DATE INPUTTED' ? 'no_set_value' : ''">{{crew.disembarkationDate}}</td>
              <td class="text-center" :class="crew.disembarkationStatus === 'NO STATUS SELECTED' ? 'no_set_value' : ''">{{crew.disembarkationStatus}}</td>
              <td class="text-center">{{crew.onboardPeriod}}</td>
<!--              <td class="text-center">{{crew.passportNumber}}</td>-->
<!--              <td class="text-center">{{crew.seamansBookNumber}}</td>-->
              <td v-show="!params.vessel_id">{{crew.vesselName + (crew.vesselFlag ? ' (' + crew.vesselFlag + ')' : '')}}</td>
              <td class="text-center">{{crew.scholar}}</td>
              <td v-show="!params.natl_id" class="text-center">{{crew.nationality}}</td>
              <td class="text-center">{{ crew.contractExpiryDate }}</td>
            </tr>
          </template>
          </tbody>
        </table>
      </div>
    </div>
    <download-pdf-loading></download-pdf-loading>
  </div>
</template>

<script>
import AppLoading from '../../../elements/AppLoading';
import {vueAppMixin} from '../../../../mixins/vueAppMixin';
import {gateMixin} from '../../../../mixins/gateMixin';
import {mapActions, mapGetters, mapMutations} from 'vuex';
import {ReportService} from '../../../../services/ReportService';
import DownloadPDFLoading from '../../../elements/DownloadPDFLoading';
import {DateService} from '../../../../services/Utilities/DateService';

export default {
  name: 'GenerateWhoIsOnboard',
  mixins: [vueAppMixin, gateMixin],
  components: { AppLoading,
    'download-pdf-loading': DownloadPDFLoading },
  data() {
    return {
      params: {
        crewOnboardFilterType: 1,
        onboard_from: DateService.dateToday(),
        onboard_to: DateService.dateToday(),
        vessel_id: null,
        manning_id: null,
        rank_id: null,
        natl_id: null,
        page: 1,
        filter: {
          minimumOnboardMonth: 8,
          minimumPeriodMonth: 1,
          maximumPeriodMonth: 13
        },
        sort_by: {
          key: null,
          direction: null
        }
      },
      modalLoad: false
    };
  },
  methods: {
    ...mapActions([
      'getVesselKeys',
      'getNatlKeys',
      'getRankKeys',
      'getManningKeys',
      'getOnboardCrewList',
      'getOnboardCrewFile',
      'setLoading'
    ]),

    ...mapMutations([
        "SET_ONBOARD_CREW_LIST",
        "setPagination"
    ]),

    async downloadOnboardList(){
      this.modalLoad = true
      document.getElementById('LoadingModal').style.display = 'block'
      !this.params.vessel_id ? this.params.vessel_id = '' : this.params.vessel_id;
      !this.params.manning_id ? this.params.manning_id = '' : this.params.manning_id;
      !this.params.rank_id ? this.params.rank_id = '' : this.params.rank_id;
      await ReportService.generateOnboardCrewFile(this.params);
      this.modalLoad = false
      document.getElementById('LoadingModal').style.display = 'none'
    },

    selectDefaultParams() {
      this.params.manning_id = "";
      this.params.vessel_id = "";
      this.params.natl_id = "";
      this.params.rank_id = "";
    },

    toggleTableHeader(key) {
      if (this.params.sort_by.key !== key) {
        this.params.sort_by.key = key;
        this.params.sort_by.direction = 'asc';
        this.setPage(1);
        return;
      }

      if (this.params.sort_by.key === key && this.params.sort_by.direction === 'asc') {
        this.params.sort_by.direction = 'desc';
        this.setPage(1);
        return;
      }

      this.params.sort_by = {
        key: null,
        direction: null
      };
      this.setPage(1);
    },

    isCurrentKeyDirection(key, direction) {
      if (this.params.sort_by.key !== key) {
        return false;
      }

      return this.params.sort_by.direction === direction;
    },

    filterOnboardCrewList() {
      this.params.page = this.pagination.currentPage;
      this.getOnboardCrewList(this.params);
    },

    async setPage(page) {
      this.pagination.currentPage = page;
      await this.filterOnboardCrewList();
    },

    updateOnboardCrewList() {
      this.pagination.currentPage = 1;
      this.getOnboardCrewList(this.params);
    },

    updateVesselKeys(){
      if (this.isOchg || !this.isSystemAdmin || this.isKobe) {
        this.params.vessel_id=null;
        let vesselParams = {
          manningId: this.params.manning_id
        };
        this.getVesselKeys(vesselParams);
      }
    },

    validateNumberInput(typeKey, value) {
      let converted_value = Number(value);

      if (converted_value === 0 && typeKey === "min") {
        this.params.filter.minimumPeriodMonth = 1;
        return;
      } else if (converted_value === 0 && typeKey === "max") {
        this.params.filter.maximumPeriodMonth = 13;
        return;
      }

      if (typeKey === "min" &&
          converted_value > this.params.filter.maximumPeriodMonth) {

        this.params.filter.minimumPeriodMonth = this.params.filter.maximumPeriodMonth;
        return;
      } else if (typeKey === "max" &&
          converted_value < this.params.filter.minimumPeriodMonth) {

        this.params.filter.maximumPeriodMonth = this.params.filter.minimumPeriodMonth;
        return;
      }

      if (typeKey === "min" && converted_value <= 0) {
        this.params.filter.minimumPeriodMonth = 1;
      } else if (typeKey === "max" && converted_value > 13) {
        this.params.filter.maximumPeriodMonth = 13;
      }
    }

  },
  computed: {
    ...mapGetters([
      'vesselKeys',
      'natlKeys',
      'rankKeys',
      'manningKeys',
      'onboardCrewList',
      'pagination',
    ]),

    paginationPages() {
      let pages = [];
      let currentPage = this.pagination.currentPage;
      let lastPage = this.pagination.lastPage;
      if (lastPage > 1) {
        let initialLimit = 1;
        if (currentPage + 5 > lastPage) {
          initialLimit = lastPage - 10;
        } else if (currentPage > 6) {
          initialLimit = currentPage - 5;
        }
        initialLimit = initialLimit < 1 ? 1 : initialLimit;
        for (let i = initialLimit; i <= initialLimit + 10; i++) {
          pages.push(i);
          if (i >= lastPage) {
            break;
          }
        }
      }
      return pages;
    },

  },
  created(){
    this.getVesselKeys();
    this.getNatlKeys();
    this.getRankKeys();
    this.getManningKeys();
    this.setLoading(false);
    this.setPagination({
      from: 0,
      to: 0,
      currentPage: 0,
      lastPage: 0,
      perPage: 0,
      total: 0
    });
    this.searchOnboardCrewList = _.debounce(this.updateOnboardCrewList, 500);
  },
  destroyed () {
    this.SET_ONBOARD_CREW_LIST([]);
    this.setPagination({
      from: 0,
      to: 0,
      currentPage: 0,
      lastPage: 0,
      perPage: 0,
      total: 0
    });
  },
  watch: {
    'params.onboard_from'() {
      if(Date.parse(this.params.onboard_from) && this.params.onboard_from > true) {
        this.searchOnboardCrewList();
      }
    },
    'params.onboard_to'() {
      if(Date.parse(this.params.onboard_to) && this.params.onboard_to > true) {
        this.searchOnboardCrewList();
      }
    },
    'params.vessel_id'() {
      this.params.page=1
      this.getOnboardCrewList(this.params);
      this.pagination.currentPage=0
      document.getElementById('vesselOption0').style.display = 'none'
    },
    'params.manning_id'() {
      this.params.page=1
      this.getOnboardCrewList(this.params);
      this.updateVesselKeys();
      this.params.vessel_id=null;
      this.pagination.currentPage=0
      document.getElementById('manningOption0').style.display = 'none'
    },
    'params.rank_id'() {
      this.params.page=1
      this.getOnboardCrewList(this.params);
      this.pagination.currentPage=0
      document.getElementById('rankOption0').style.display = 'none'
    },
    'params.natl_id'() {
      this.params.page=1
      this.getOnboardCrewList(this.params);
      this.pagination.currentPage=0
      document.getElementById('natlOption0').style.display = 'none'
    },
    'params.page'() {
      this.getOnboardCrewList(this.params);
    },
    'params.crewOnboardFilterType'() {
      this.params.page=1;
      this.selectDefaultParams();
      this.params.filter.minimumOnboardMonth = 8;
      this.params.filter.maximumPeriodMonth = 13;
      this.params.filter.minimumPeriodMonth = 1;
      this.getOnboardCrewList(this.params);
    },
    'params.filter.minimumOnboardMonth'() {
      this.params.page=1
      this.getOnboardCrewList(this.params);
      this.pagination.currentPage = 0;
    },
  },
};
</script>

<style scoped>
  .current_direction {
    color: #25ba39
  }

  .no_set_value {
	color: grey;
  }
</style>
